export default __webpack_public_path__ + "static/media/coding_undraw.676376eb.svg";